import { render, staticRenderFns } from "./slide-default.vue?vue&type=template&id=833e3ebe&"
import script from "./slide-default.vue?vue&type=script&lang=js&"
export * from "./slide-default.vue?vue&type=script&lang=js&"
import style0 from "./slide-default.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports